import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonMenu, IonMenuToggle, IonAvatar, IonText, IonLoading } from '@ionic/react';
import {
  calendarOutline,
  logIn,
  logOut,
  reload,
  peopleOutline,
  schoolOutline,
  person,
  cardOutline,
  checkboxOutline,
  walletOutline,
  starOutline,
  notificationsOutline,
  ribbonOutline,
  personCircleOutline
} from 'ionicons/icons';

import { connect } from '../data/connect';
import {
  setDarkMode,
  setIsLoggedIn,
  setUsername,
  setUserCed,
  setUserID,
  setUserOther,
  setEventCode,
  setEventName,
  setEventStartDate,
  setEventEndDate,
  setEventLocation
} from '../data/user/user.actions';
import { setShowEventsModal } from '../data/eventsModal/events.actions';
import { clearCacheAndReload } from '../utils/offlineManager';
import { Evento, loginWithEvent } from '../data/eventsModal/events.service';
import {
  AdministrativeSectionKey,
  getEnabledAdministrativeSections,
  isFeatureEnabled,
  isMultieventEnabled
} from '../config/app.config';
import { getDefaultAvatar } from '../utils/defaultAvatar';
import UserAvatar from './UserAvatar';

import './Menu.css'

const routes = {
  appPages: [
    { title: 'Agenda', path: '/tabs/schedule', icon: calendarOutline },
    { title: 'Conferencistas', path: '/tabs/speakers', icon: peopleOutline },
    // Botón de Mapa oculto por solicitud del cliente
    // { title: 'Mapa', path: '/tabs/map-iframe', icon: mapOutline },
    //{ title: 'GALERIA (Próximamente)', path: '#', icon: informationCircleOutline },
    //{ title: 'POSTERS IESTEC (próximamente)', path: '/#1', icon: informationCircleOutline },
    //{ title: 'EN VIVO', path: '/live', icon: informationCircleOutline }
    //{ title: 'About', path: '/tabs/about', icon: informationCircleOutline }
  ],
  loggedInPages: [
    { title: 'Perfil', path: '/account', icon: person },
    { title: 'Carnet Digital', path: '/carnet-digital', icon: cardOutline },
    //{ title: 'Support', path: '/support', icon: help },
    { title: 'Cerrar Sesión', path: '/logout', icon: logOut },
    //{ title: 'JIC', path: '/jic', icon: informationCircleOutline }
  ],
  loggedOutPages: [
    { title: 'Ingresar', path: '/login', icon: logIn },
    //{ title: 'Support', path: '/support', icon: help },
    //{ title: 'Registro', path: '/signup', icon: personAdd }
  ]
};

const administrativeSectionIcons: Record<AdministrativeSectionKey, string> = {
  membership: personCircleOutline,
  associationEvents: calendarOutline,
  participation: checkboxOutline,
  accountStatement: walletOutline,
  digitalCard: cardOutline,
  benefits: starOutline,
  news: notificationsOutline,
  certificates: ribbonOutline
};

interface Pages {
  title: string,
  path: string,
  icon: string,
  routerDirection?: string
}
interface StateProps {
  darkMode: boolean;
  isAuthenticated: boolean;
  menuEnabled: boolean;
  username?: string;
  userced?: string;
  userother?: string;
  eventCode?: string;
  hasScheduleData: boolean;
  hasSpeakersData: boolean;
}

interface DispatchProps {
  setDarkMode: typeof setDarkMode;
  setShowEventsModal: typeof setShowEventsModal;
  setIsLoggedIn: typeof setIsLoggedIn;
  setUsername: typeof setUsername;
  setUserCed: typeof setUserCed;
  setUserID: typeof setUserID;
  setUserOther: typeof setUserOther;
  setEventCode: typeof setEventCode;
  setEventName: typeof setEventName;
  setEventStartDate: typeof setEventStartDate;
  setEventEndDate: typeof setEventEndDate;
  setEventLocation: typeof setEventLocation;
}

interface MenuProps extends RouteComponentProps, StateProps, DispatchProps { }

const Menu: React.FC<MenuProps> = ({
  isAuthenticated,
  menuEnabled,
  username,
  userother,
  userced,
  eventCode,
  setShowEventsModal,
  setIsLoggedIn,
  setUsername: setUsernameAction,
  setUserCed,
  setUserID,
  setUserOther,
  setEventCode,
  setEventName,
  setEventStartDate,
  setEventEndDate,
  setEventLocation,
  hasScheduleData,
  hasSpeakersData,
  history
}) => {
  const [loading, setLoading] = useState(false);
  const administrativePages: Pages[] = getEnabledAdministrativeSections().map(section => ({
    title: section.label || section.description,
    path: section.route,
    icon: administrativeSectionIcons[section.key]
  }));

  function renderlistItems(list: Pages[]) {
    return list
      .filter(route => {
        // Filtrar elementos según la disponibilidad de datos
        if (route.title === 'Agenda' && !hasScheduleData) {
          return false; // Ocultar Agenda si no hay datos de schedule
        }
        if (route.title === 'Conferencistas' && !hasSpeakersData) {
          return false; // Ocultar Conferencistas si no hay datos de speakers
        }
        if (route.path === '/carnet-digital' && !isFeatureEnabled('carnetDigital')) {
          return false;
        }
        return !!route.path; // Mantener el filtro original para otras rutas
      })
      .map(p => (
        <IonMenuToggle key={p.title} auto-hide="false">
          <IonItem detail={false} routerLink={p.path} routerDirection="none"
            className="menu-item"
            lines="none">
            <IonIcon slot="start" icon={p.icon} />
            <IonLabel>{p.title}</IonLabel>
          </IonItem>
        </IonMenuToggle>
      ));
  }

  return (
    <IonMenu type="overlay" disabled={!menuEnabled} contentId="main" className="app-menu">
      <IonContent forceOverscroll={false} className="menu-content">
        {/* Profile section - Based on reference UI */}
        {isAuthenticated && username && (
          <div className="profile-section p-4 my-4 mx-3 text-center">
            <UserAvatar
              size="medium"
              className="menu-avatar"
              alt="Foto de perfil"
            />
            <IonText>
              <h2 className="profile-name" style={{color: '#ffffff !important'}}>{username}</h2>
              <p className="profile-info" style={{color: '#ffffff !important'}}>{userother?.split("&&&")[0]}</p>
            </IonText>
            {userother && (
              <div className="badge-category-menu ion-margin-vertical">
                <div className="ion-padding" style={{borderRadius: '50px', background: 'var(--app-button-gradient)', color: 'white !important', fontWeight: '600', letterSpacing: '0.5px', textShadow: '0 1px 2px rgba(0,0,0,0.2)', whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip', lineHeight: '1.4', padding: '10px 15px'}}>
                  {userother.split("&&&")[1]}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Menu items - Based on reference UI */}
        <div className="menu-section ion-margin">
          {/*<IonItem lines="none" className="menu-item" detail={false}>
            <IonIcon slot="start" icon={settingsOutline} />
            <IonLabel>Setting</IonLabel>
          </IonItem>

          <IonItem lines="none" className="menu-item" detail={false}>
            <IonIcon slot="start" icon={settingsOutline} />
            <IonLabel>Theme setting</IonLabel>
          </IonItem>*/}

          {renderlistItems(routes.appPages)}

          {isAuthenticated && administrativePages.length > 0 && (
            <>
              <div className="menu-section-label">Servicios administrativos</div>
              {renderlistItems(administrativePages)}
            </>
          )}

          {isAuthenticated ? renderlistItems(routes.loggedInPages) : renderlistItems(routes.loggedOutPages)}

          {/* Botón de modo oscuro oculto por solicitud del cliente */}
          {/* <IonItem lines="none" className="menu-item">
            <IonIcon slot="start" icon={moonOutline}></IonIcon>
            <IonLabel>Modo Oscuro</IonLabel>
            <IonToggle checked={darkMode} onClick={() => setDarkMode(!darkMode)} />
          </IonItem> */}

          {/* Botón de FAQ oculto por solicitud del cliente */}
          {/* <IonItem lines="none" className="menu-item" detail={false}>
            <IonIcon slot="start" icon={helpCircleOutline} />
            <IonLabel>FAQ</IonLabel>
          </IonItem> */}

          {isAuthenticated && isMultieventEnabled() && (
            <IonItem lines="none" className="menu-item" detail={false} button onClick={() => {
              // Mostrar el modal de eventos
              setShowEventsModal(true);

              // Cerrar el menú lateral
              const menu = document.querySelector('ion-menu');
              if (menu) {
                (menu as any).close();
              }
            }}>
              <IonIcon slot="start" icon={schoolOutline} />
              <IonLabel>Eventos</IonLabel>
            </IonItem>
          )}

          {/* Indicador de carga */}
          <IonLoading
            isOpen={loading}
            message={'Cargando...'}
            duration={5000}
          />

          <div className="ion-padding-horizontal ion-padding-bottom">
            <IonButton expand="block" onClick={() => clearCacheAndReload()} className="primary-action-button ion-margin">
              <IonIcon slot="start" icon={reload}></IonIcon>
              Actualizar App
            </IonButton>
          </div>
        </div>
        {/*<IonList lines="none">
          <IonListHeader>Tutorial</IonListHeader>
          <IonItem button onClick={() => {
            history.push('/tutorial');
          }}>
            <IonIcon slot="start" icon={hammer} />
            Show Tutorial
          </IonItem>
        </IonList>*/}
      </IonContent>
    </IonMenu>
  );
};

export default connect<{}, StateProps, DispatchProps>({
  mapStateToProps: (state) => ({
    darkMode: state.user.darkMode,
    isAuthenticated: state.user.isLoggedin,
    menuEnabled: state.data.menuEnabled,
    username: state.user.username,
    userced: state.user.userced,
    userother: state.user.userother,
    eventCode: state.user.eventcode,
    hasScheduleData: state.data.schedule && state.data.schedule.groups && state.data.schedule.groups.length > 0,
    hasSpeakersData: state.data.speakers && state.data.speakers.length > 0
  }),
  mapDispatchToProps: {
    setDarkMode,
    setShowEventsModal,
    setIsLoggedIn,
    setUsername,
    setUserCed,
    setUserID,
    setUserOther,
    setEventCode,
    setEventName,
    setEventStartDate,
    setEventEndDate,
    setEventLocation
  },
  component: withRouter(Menu)
})
